import { RequestPasswordResetInteractor, RequestPasswordResetRequest } from "../../Coordinator/RequestPasswordReset/RequestPasswordResetInteractor";

export class RequestPasswordResetViewModel {
	private interactor: RequestPasswordResetInteractor;

	constructor() {
		this.interactor = new RequestPasswordResetInteractor();
	}

	public fetchSave(obj: any): Promise<boolean> {
		const request = new RequestPasswordResetRequest(obj["email"] ?? "");

		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(result)
			}, (e) => {
				return rej(e)
			}
			);
		});
	}
}